// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__295Er","tag":"Price_tag__1YsbI","amount-currency":"Price_amount-currency__x-84Y","lg":"Price_lg__1Kpe5","free":"Price_free__19VAY"};